import { http } from '../../config/axios'

 const findFatura = (params:any): Promise<any> => {
  const queryParams = params
                ? Object.keys(params)
                      .map((k) => encodeURIComponent(params[k]))
                      .join('/')
                : '';
  return http
    .get('api/fatura/find/' + queryParams)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findFatura', error)
      throw Error(error.response.data)
    })
}

export default findFatura;
